export async function uploadProductImages(productName, files) {
    const fd = new FormData();
    fd.append("productName", productName);

    // multi
    for (const f of files) fd.append("files[]", f);

    const res = await fetch("https://www.rotheras.gr/upls/imagePG.php", {
        method: "POST",
        body: fd,
    });

    const data = await res.json();
    console.log("Upload response:", data); // Add this line
    if (!res.ok) throw new Error(data?.error || "Upload failed");
    return data.urls ?? [];
}
